import { Schema } from '../../Entities/Schema.entity';
import { createSchema } from '../../Utils/CreateSchema';

export const signupStartSchema: Schema = {
  ...createSchema({
    version: '1-0-1',
    description: 'Tracks when a user starts the signup process',
    name: 'signup_start',
    properties: {
      source: {
        type: 'string',
        description: 'The source where the signup was initiated from',
      },
    },
  }),
};
